import util from "utils/utils"

import BaseChip, { type ChipConfiguration } from "./BaseChip"

const ProfileChip = ({
  profile,
  ...props
}: ChipConfiguration & {
  profile: {
    _id: string
    name: string
    overview?: string
  }
}) => {
  return (
    <BaseChip
      {...props}
      style={{ maxWidth: 200 }}
      linkTo={`/profiles/${profile?._id}`}
      title={profile?.name}
      description={profile?.overview}
      imageUrl={util.profileLogo(profile)}
    />
  )
}

export default ProfileChip
